module.exports = __webpack_public_path__ + "img/pencilline.19178156.svg";